import { EditingSnippetProps, EditingRollupScreenProps } from '../../app/Navigation';
import { Route } from '../../app/Route';
import { Snippet } from '../../services/dataModels';

export const navigateToSnippet = (navigation: any, snippet: Snippet, params: any) => {
  const open = navigation.push ?? navigation.navigate;

  if (snippet.groupSnippets?.length > 0) {
    open(Route.editingGroupScreen, params);
  } else {
    switch (snippet.type) {
      case 'RollupComment':
      case 'RollupDataEntryTable':
      case 'RollupMatrix':
        open(Route.editingRollupScreen, params);
        break;

      case 'Comment':
        open(Route.editingRowScreen, params);
        break;

      default:
        open(Route.editingRowListScreen, params);
        break;
    }
  }
};

export const findSnippet = ({ snippetId }: EditingSnippetProps, snippets: Snippet[]) => {
  return snippets.find((s) => s.shiftsummaryDisplyId === snippetId);
};

export const findGroupSnippet = (
  params: EditingRollupScreenProps,
  snippets: Snippet[],
): [string, Snippet] => {
  const rootSnippet = findSnippet(params, snippets);
  return typeof params.groupIndex !== 'undefined'
    ? [
        params.groupIndex.reduce((acc, cur) => `${acc}.groupSnippets[${cur}]`, '').substring(1) +
          '.',
        params.groupIndex.reduce((acc, cur) => acc.groupSnippets[cur], rootSnippet),
      ]
    : ['', rootSnippet];
};
